import React from 'react';

const KeycloakIcon = () => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.20985 19.7799C7.16985 22.7299 11.9699 22.7299 14.9099 19.7799C16.9799 17.7299 17.5999 14.7799 16.7999 12.1799L21.4999 7.47993C21.8299 7.13993 22.0599 6.46993 21.9899 5.98993L21.6899 3.80993C21.5799 3.08993 20.9099 2.40993 20.1899 2.30993L18.0099 2.00993C17.5299 1.93993 16.8599 2.15993 16.5199 2.50993L15.6999 3.32993C15.4999 3.51993 15.4999 3.83993 15.6999 4.03993L17.6399 5.97993C17.9299 6.26993 17.9299 6.74993 17.6399 7.03993C17.3499 7.32993 16.8699 7.32993 16.5799 7.03993L14.6299 5.08993C14.4399 4.89993 14.1199 4.89993 13.9299 5.08993L11.8099 7.19993C9.21985 6.38993 6.26985 7.01993 4.20985 9.06993C1.25985 12.0199 1.25985 16.8299 4.20985 19.7799ZM9.49985 11.9999C10.8799 11.9999 11.9999 13.1199 11.9999 14.4999C11.9999 15.8799 10.8799 16.9999 9.49985 16.9999C8.11985 16.9999 6.99985 15.8799 6.99985 14.4999C6.99985 13.1199 8.11985 11.9999 9.49985 11.9999Z"
          fill="#746D67"
        />
      </svg>
    </div>
  );
};

export default KeycloakIcon;
